import react, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import style from 'styles/badge.module.scss';
import classnames from 'classnames';
import { Edit2, Trash, X } from 'react-feather';
import { Button } from 'reactstrap';
import { useRouter } from 'next/router';
import BadgeApi from 'api/badgeApi';
import { useUser } from 'hooks';
import Avatar from 'components/Layout/Avatar/Avatar';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { AiFillLeftCircle, AiFillRightCircle } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { getColor, getColorText, getThemeColor } from 'store/settings';
import styled from '@emotion/styled';
import { handleToastError } from 'helpers';
const ModalBadges = (props) => {
  const router = useRouter();
  const user = useUser();
  const [badgeCount, setBadgeCount] = useState(0);
  const [badge, setBadge] = useState([]);
  const closeModal = () => {
    props.toggle();
  };
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    .btn-danger {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn-danger:hover {
      background-color: #ffffff !important;
      color: ${colorStatus} !important;
      border-color: ${colorStatus} !important;
    }
  `;
  function SlideNextArrow({ onClick }) {
    const themeStatus = useSelector(getThemeColor);
    const Stylescal = styled.div`
      .arrow {
        font-size: 35px;
        display: flex;
        position: absolute;
        top: 130.5px;
        color: #c8c8c8;
      }
      .arrow:hover {
        font-size: 35px;
        display: flex;
        position: absolute;
        top: 130.5px;
        color: ${themeStatus};
      }
    `;
    return (
      <Stylescal>
        <div
          className={classnames(
            'arrow',
            'arrow-right',
            style['arrow-right'],
            style['arrow'],
          )}
        >
          <AiFillRightCircle onClick={onClick} />
        </div>
      </Stylescal>
    );
  }

  function SlidePrevArrow({ onClick }) {
    const themeStatus = useSelector(getThemeColor);
    const Stylescal = styled.div`
      .arrow {
        font-size: 35px;
        display: flex;
        position: absolute;
        top: 130.5px;
        color: #c8c8c8;
      }
      .arrow:hover {
        font-size: 35px;
        display: flex;
        position: absolute;
        top: 130.5px;
        color: ${themeStatus};
      }
    `;
    return (
      <Stylescal>
        <div
          className={classnames(
            'arrow',
            'arrow-left',
            style['arrow-left'],
            style['arrow'],
          )}
        >
          <AiFillLeftCircle onClick={onClick} />
        </div>
      </Stylescal>
    );
  }
  const sliderProperties = {
    prevArrow: <SlidePrevArrow />,
    nextArrow: <SlideNextArrow />,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    lazyLoad: true,
    speed: 300,
    autoplay: false,
    responsive: [
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 912,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1090,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const getUserBadge = async () => {
    try {
      const resposne = await BadgeApi.getUserBadges(user?._id);
      if (resposne?.length) {
        let badgeArray = [];
        resposne?.map((data) => {
          if (data?.badgeEnabled) {
            if (data?.allowDuplicateBadgeCount > 1) {
              [...Array(data?.allowDuplicateBadgeCount)].map((item, ii) => {
                badgeArray.push(data);
              });
            } else {
              badgeArray.push(data);
            }
          }
        });
        setBadgeCount(badgeArray?.length);
        setBadge(badgeArray);
      }
    } catch (e) {
      handleToastError(e);
    }
  };

  useEffect(() => {
    getUserBadge();
  }, []);
  return (
    <div>
      <Modal className={classnames('modal-drogdrop')} show={props.open}>
        <Modal.Header>
          <label
            className={classnames(
              'add-type-heading',
              style['add-type-heading'],
            )}
          >
            My Acheievments
          </label>

          <span
            className="btn  btn-large "
            color="secondary"
            outline
            onClick={closeModal}
          >
            <X />
          </span>
        </Modal.Header>
        <Modal.Body>
          <div
            className={classnames(
              'modal-background-clr',
              style['modal-background-clr'],
            )}
          >
            <label
              className={classnames('basic_detail', style['basic_detail'])}
            >
              Badges
            </label>
          </div>
          {badge?.length ? (
            <div>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4"></div>
                  <div className="col-md-4">
                    <Slider {...sliderProperties}>
                      {badge.map((el, i) => (
                        <div key={i} className="text-center mt-2">
                          <Avatar
                            size={153}
                            source={
                              process.env.NEXT_PUBLIC_API_URL + el.thumbnail
                            }
                            className="header__avatar-group--image "
                          />
                          {/* <img src="/images/badge/badge-count.png" /> */}
                        </div>
                      ))}
                    </Slider>
                  </div>
                  <div className="col-md-4"></div>
                </div>
              </div>
              <div className="text-center mt-1">
                <label
                  className={classnames(
                    'badge-collection-count',
                    style['badge-collection-count'],
                  )}
                >
                  {badgeCount}
                </label>
              </div>
            </div>
          ) : (
            <div>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4"></div>
                  <div className="col-md-4">
                    <div className="text-center mt-2">
                      <Avatar
                        size={153}
                        source="/images/badge/badge-count.png"
                        className="header__avatar-group--image "
                      />
                    </div>
                  </div>
                  <div className="col-md-4"></div>
                </div>
              </div>
              <div className="text-center mt-1">
                <label
                  className={classnames(
                    'badge-collection-count',
                    style['badge-collection-count'],
                  )}
                >
                  0
                </label>
              </div>
            </div>
          )}
          <div className="text-center mt-1">
            <Stylescal>
              <button
                className="btn btn-danger"
                onClick={() => router.push(`/Badge/badge`)}
              >
                My Badges Collections
              </button>
            </Stylescal>
          </div>
        </Modal.Body>
        <Modal.Footer className="p-1">
          <Stylescal>
            <Button color="danger" onClick={closeModal}>
              Back
            </Button>
          </Stylescal>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalBadges;
